"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Modal = Modal;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("./Button"));

function Modal(_ref) {
  var className = _ref.className,
      dialog = _ref.dialog,
      children = _ref.children,
      onClose = _ref.onClose,
      contentClassname = _ref.contentClassname;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, !dialog && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClose,
    className: "modal-mask"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-outer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: contentClassname
  }, !!onClose && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClose,
    className: "modal-close"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Close")), children)));
}

Modal.propTypes = {
  className: _propTypes["default"].string,
  contentClassname: _propTypes["default"].string,
  dialog: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  children: _propTypes["default"].node
};
Modal.defaultProps = {
  contentClassname: 'modal-content'
};
var _default = Modal;
exports["default"] = _default;